var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellsIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.88889 11.7778C6.88889 14.371 7.91904 16.858 9.75273 18.6917C11.5864 20.5254 14.0734 21.5556 16.6667 21.5556C19.2599 21.5556 21.7469 20.5254 23.5806 18.6917C25.4143 16.858 26.4444 14.371 26.4444 11.7778C26.4444 9.18455 25.4143 6.69753 23.5806 4.86384C21.7469 3.03016 19.2599 2 16.6667 2C14.0734 2 11.5864 3.03016 9.75273 4.86384C7.91904 6.69753 6.88889 9.18455 6.88889 11.7778Z",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 46V41.1112C2 38.5179 3.03016 36.0309 4.86384 34.1972C6.69753 32.3635 9.18455 31.3334 11.7778 31.3334H21.5556C24.1488 31.3334 26.6358 32.3635 28.4695 34.1972C30.3032 36.0309 31.3333 38.5179 31.3333 41.1112V46",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.7778 2.3175C35.881 2.85602 37.7452 4.07922 39.0765 5.79426C40.4077 7.50931 41.1303 9.61864 41.1303 11.7897C41.1303 13.9608 40.4077 16.0701 39.0765 17.7852C37.7452 19.5002 35.881 20.7234 33.7778 21.2619",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46 45.9997V41.1108C45.9876 38.9528 45.2616 36.8594 43.9351 35.1571C42.6086 33.4548 40.7562 32.2392 38.6667 31.6997",
    stroke: "#FFDB59",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellsIcon1);
export default __webpack_public_path__ + "static/media/sells-icon1.08e0ce80e599f2dcd85bdf78923e020e.svg";
export { ForwardRef as ReactComponent };